import { useCallback, useEffect } from "react";
import { AuthMode } from "constants/auth";
import { LOCAL_STORAGE_KEY } from "constants/localStorage";
import ls from 'local-storage';
import { useMappedState } from "redux-react-hook";
import { isBlank } from "utils/storeUtils";


export const useEmailVerificationCheck = (openAuthModal: () => void, authMode: AuthMode, setAuthMode: (newAuthMode: AuthMode) => AuthMode) => {

  const { currentUser } = useMappedState(
    useCallback(state => {
      const currentUser = state.users.usersMap.get(state.users.currentUserId);
      return { currentUser };
    }, [])
  );

  useEffect(() => {

    if (currentUser?.emailVerified || isBlank(currentUser)) {
      return;
    }

    // @ts-ignore
    const isMailVerificationAlreadyShown = ls.get(
      LOCAL_STORAGE_KEY.IS_MAIL_VERIFICATION_ALREADY_SHOWN
    );

    if (isMailVerificationAlreadyShown) return;
    if (authMode) {
      setAuthMode(authMode);
    }
    openAuthModal();
  }, [currentUser, openAuthModal]);
};
